import { motion } from "framer-motion";
import type { MaterialUsage } from "@/store/dashboardStore";

const EASE = [0.22, 1, 0.36, 1] as const;

export function MaterialsBarChart({ materials }: { materials: MaterialUsage[] }) {
  return (
    <div data-testid="materials-bar-chart" className="flex h-44 items-end gap-3 sm:gap-5">
      {materials.map((m, i) => {
        const pct = m.total ? m.used / m.total : 0;
        return (
          <div key={m.name} className="flex flex-1 flex-col items-center gap-3">
            <div className="relative flex h-32 w-full max-w-[44px] flex-col justify-end overflow-hidden rounded-md bg-cad/25">
              <motion.div
                data-testid={`materials-bar-${m.name.toLowerCase()}`}
                initial={{ height: 0 }}
                animate={{ height: `${Math.max(pct * 100, pct > 0 ? 3 : 0)}%` }}
                transition={{ delay: 0.5 + i * 0.07, duration: 0.8, ease: EASE }}
                className="w-full rounded-md bg-safety shadow-[0_0_20px_-6px_rgba(255,91,0,0.7)]"
              />
              <span
                aria-hidden
                className="pointer-events-none absolute inset-x-0 top-0 h-px bg-white/10"
              />
            </div>
            <div className="flex flex-col items-center gap-0.5">
              <span className="font-mono text-[10px] uppercase tracking-[0.16em] text-white/70">{m.name}</span>
              <span className="font-mono text-[10px] tracking-[0.08em] text-cad">{Math.round(pct * 100)}%</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
